/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import styled from "styled-components";

export const ColouredBackground = styled.div`
  min-height: 120vh;
  min-width: 120vw;
  position: fixed;
  margin-left: -20px;
  top: 0;
  z-index: -2;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  background-position: center;
`;

export const ContainedSurface = styled.div`
  position: relative;
  min-height: 400px;
  overflow: auto;
`;

export const ContainedColouredBackground = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

export const ContainedContent = styled.div`
  position: relative;
  z-index: 1;
  padding: 10px 0;
`;
